import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { ElementFactory, checkNotOverLimit } from "./util";
export function StoryblokRenderer(param) {
    var block = param.block, components = param.components, props = param.props, componentsWithWrapper = param.componentsWithWrapper, limitedItems = param.limitedItems;
    if (Array.isArray(block)) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: block.map(function(blockElement, index) {
                return checkNotOverLimit(blockElement, limitedItems) ? /*#__PURE__*/ _createElement("div", _object_spread_props(_object_spread({}, storyblokEditable(blockElement)), {
                    key: index
                }), ElementFactory(blockElement, components, props, componentsWithWrapper)) : null;
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, storyblokEditable(block)), {
        children: ElementFactory(block, components, props)
    }));
}
